export interface MobileBffAddCardResponseDto {
  formUrl: string;
  successUrl: string;
  failedUrl: string;
}
